import { myVisitCounselApi, type PlannerApiError } from '@/entities/planner/model/my-planner.api';

/** 서버 DomainErrorCode — 이미 반영된 단계라 재시도가 무의미한 409 */
const ALREADY_REVIEWED = 'VISIT_COUNSEL_016';
const ALREADY_COMPLETED = 'VISIT_COUNSEL_018';

function hasErrorCode(err: unknown, code: string): boolean {
  return err instanceof Error && (err as PlannerApiError).code === code;
}

/**
 * 리뷰 → 상담 종료를 멱등하게 수행한다.
 *
 * 이미 반영된 단계(ALREADY_REVIEWED / ALREADY_COMPLETED)는 성공으로 간주하고
 * 다음 단계로 진행한다 — 성공 응답이 유실된 뒤 재진입했을 때 409 를 실패로 읽어
 * 종료 단계에 영영 도달하지 못하는 루프를 막는다.
 * (2026-08-10 주문 2018830: 리뷰는 서버에 반영됐지만 응답 유실 → 재진입 20회가
 *  전부 VISIT_COUNSEL_016(409)로 실패 처리되어 counsel/complete 가 한 번도 호출되지 않았다)
 *
 * 그 외 409(예: VISIT_COUNSEL_015 세션 미완료, VISIT_COUNSEL_017 리뷰 필요)는
 * 실제 선행조건 위반이므로 그대로 던진다.
 */
export async function finishCounsel(visitCounselId: string): Promise<void> {
  try {
    await myVisitCounselApi.markSessionReviewed(visitCounselId);
  } catch (err) {
    if (!hasErrorCode(err, ALREADY_REVIEWED)) throw err;
  }
  try {
    await myVisitCounselApi.completeVisitCounsel(visitCounselId);
  } catch (err) {
    if (!hasErrorCode(err, ALREADY_COMPLETED)) throw err;
  }
}
